import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@viastud/ui/lib/trpc'
import { z } from 'zod'

import { StudentSubscriptionTab } from '@/components/settings/student-subscription-tab'
import { useAuthStore } from '@/store/auth.store'

const searchSchema = z.object({
  payment_intent: z.string().optional(),
  redirect_status: z.string().optional(),
  tab: z.enum(['ACCOUNT', 'SUBSCRIPTION']).optional(),
})

export const Route = createFileRoute('/_student/_layout/settings')({
  validateSearch: (search) => searchSchema.parse(search),
  component: Settings,
})

function Settings() {
  const authState = useAuthStore()
  const { data: websiteStatus } = trpc.oneTimePeriod.getWebsiteStatusByUser.useQuery()

  if (authState.role !== 'STUDENT') return

  // Si l'utilisateur est inscrit à une one time subscription, masquer l'onglet abonnement
  const hideSubscriptionTab =
    process.env.NODE_ENV === 'production' &&
    websiteStatus?.oneTimePeriod === true &&
    websiteStatus.isSubscribed

  if (hideSubscriptionTab) return null

  return (
    <>
      <StudentSubscriptionTab />
      <div className="mt-8 flex w-full justify-center pb-8">
        <p className="text-xs text-slate-400">Version {APP_VERSION}</p>
      </div>
    </>
  )
}
